export class LoginModel {

    public email: string = "";
    public password: string = "";
    public error: string = null;

}
